import { useEffect } from 'react'

import { MediaElement } from '@/components/base/media'
import Typography from '@/components/base/typography'
import FullscreenCard from '@/components/sections/fullscreen-card'
import { useStore } from '@/contexts/store'
import { useLayoutStore } from '@/store/layout'
import { useLoaderStore } from '@/store/loader'

import { cn } from '@/lib/utils'
import { WPPage } from '@/types'

type ThankYouPageProps = {
  pageProps: WPPage &
    Partial<{
      acf: {
        title: string
        description: string
        media: MediaElement
      }
    }>
}

const ThankYouPage = ({ pageProps }: ThankYouPageProps) => {
  const { strings } = useStore()
  const setLoaderState = useLoaderStore((state) => state.setLoaderState)
  const setLayoutState = useLayoutStore((state) => state.setLayoutState)
  const { footer } = strings || {}

  useEffect(() => {
    setLoaderState({ heroCanPlay: true })
    setLoaderState({ isPosterReady: true })
  }, [setLoaderState])

  useEffect(() => {
    setLayoutState({ viewLogo: true, footerVisible: false })

    return () => {
      setLayoutState({ viewLogo: false, footerVisible: false })
    }
  }, [setLayoutState])

  return (
    <div className="flex w-full flex-col bg-black">
      <FullscreenCard
        media={pageProps?.acf?.media || ({} as MediaElement)}
        card={{ media: pageProps?.acf?.media || ({} as MediaElement) }}
        keywords={{
          list: pageProps?.acf?.title ? [{ word: pageProps.acf.title }] : []
        }}
        description={pageProps?.acf?.description || ''}
        isThankYouPage={true}
      />
      <div className="flex w-full px-[4rem] py-[3.6rem]">
        <Typography
          className={cn(
            'flex text-[1.28rem] capitalize tracking-[0.0384rem]',
            'text-white/50'
          )}
          data-motion-colophon
        >
          {footer?.colophon.replace('[YEAR]', new Date().getFullYear())}
        </Typography>
      </div>
    </div>
  )
}

export default ThankYouPage
